import { Component, Input, OnInit } from '@angular/core';
import { MessageType } from './message-type.enum';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @Input() message: string;
  @Input() severity: MessageType;

  constructor() { }

  ngOnInit() {
  }

}
